import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  dialog: {
    width: 480
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center'
  },
  title: {
    justifyContent: 'center',
    fontSize: 28,
    ...reskinStyles(theme, theme.modalTitle)
  },
  message: {
    justifyContent: 'center',
    marginTop: theme.spacing(6)
  },
  error: {
    justifyContent: 'center',
    marginTop: theme.spacing(4),
    color: theme.colors.error
  },
  confirmButton: {
    minWidth: 255,
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(4)
  }
}));
